import { Autocomplete, TextField } from '@mui/material';
import { sortBy } from 'lodash';
import React from 'react';

interface IItemsAutocompleteProps<T extends { id: string; name: string }> {
	id: string;
	formik: any;
	textLabel: string;
	data: T[];
}

const FormikItemsAutocomplete: React.FC<IItemsAutocompleteProps<any>> = ({
	id,
	formik,
	data,
	textLabel,
	...props
}) => {
	const options = React.useMemo(
		() => sortBy(data || [], (v) => v.name.toLowerCase()),
		[data]
	);
	return (
		<Autocomplete
			data-testid={`items-${id}-autocomplete`}
			multiple
			filterSelectedOptions
			id={id}
			isOptionEqualToValue={(option, value) => option.id === value.id}
			value={formik.values[id] || []}
			options={options}
			getOptionLabel={(option) => option?.name}
			onChange={(_, v) => {
				formik.setFieldValue(id, v || []);
			}}
			renderInput={(params) => (
				<TextField {...params} label={textLabel} fullWidth />
			)}
			{...props}
		/>
	);
};

export default FormikItemsAutocomplete;
